import React, { useRef } from "react";
import logo from "../../components/logo.png";
import { useParams } from "react-router-dom";

function Cashout() {
  const linkRef = useRef(null);
  const { amount } = useParams();

  const handleCopy = () => {
    if (linkRef.current) {
      navigator.clipboard.writeText(linkRef.current.href);
      // Optionally, provide feedback to the user
      alert("Link copied to clipboard!");
    }
  };
  return (
    <div className="cashout">
      <div className="cashout_logo">
        <img src={logo} alt="" />
      </div>
      <h1>Carolina Sauce Methods</h1>
      <h2>Check out</h2>
      <p style={{ textAlign: "center" }}>
        Pay to the ApplePay and wait to be verified by the Admin. Once verified,
        you can proceed to access the resources.
      </p>
      <h2>${amount}</h2>
      <h3>Apple Pay</h3>
      <p>+1 (678) 590-7806</p>
    </div>
  );
}

export default Cashout;
